import { MARKET_DEFAULT_LANG, marketFromUrl, marketFromStorage } from "@/lib/market";

export const LANGS = ["zh-CN", "zh-TW", "en", "vi", "th", "ms"];
export const DEFAULT_LANG = "zh-CN";
export const STORAGE_KEY = "app_lang";

export function langFromUrl() {
  try {
    const v = new URLSearchParams(window.location.search).get("lang");
    return LANGS.includes(v) ? v : null;
  } catch (e) {
    return null;
  }
}

export function langFromStorage() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return LANGS.includes(v) ? v : null;
  } catch (e) {
    return null;
  }
}

export function langFromNavigator() {
  const list = (
    navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language]
  ).filter(Boolean);
  for (const raw of list) {
    const tag = String(raw).toLowerCase();
    if (tag === "zh-tw" || tag === "zh-hk" || tag === "zh-mo" || tag.includes("hant")) {
      return "zh-TW";
    }
    if (tag === "zh" || tag.startsWith("zh-")) return "zh-CN";
    if (tag === "en" || tag.startsWith("en-")) return "en";
    if (tag === "vi" || tag.startsWith("vi-")) return "vi";
    if (tag === "th" || tag.startsWith("th-")) return "th";
    if (tag === "ms" || tag.startsWith("ms-")) return "ms";
  }
  return null;
}

export function countryToLang(country) {
  switch ((country || "").toUpperCase()) {
    case "VN":
      return "vi";
    case "TH":
      return "th";
    case "MY":
      return "ms";
    case "CN":
      return "zh-CN";
    case "TW":
    case "HK":
    case "MO":
      return "zh-TW";
    case "SG":
      return "en";
    default:
      return DEFAULT_LANG;
  }
}

export function resolveSync() {
  const direct = langFromUrl() || langFromStorage();
  if (direct) return { lang: direct, needsGeo: false };
  const market = marketFromUrl() || marketFromStorage();
  const marketLang = market ? MARKET_DEFAULT_LANG[market] : null;
  if (marketLang) return { lang: marketLang, needsGeo: false };
  const nav = langFromNavigator();
  return nav ? { lang: nav, needsGeo: false } : { lang: DEFAULT_LANG, needsGeo: true };
}
